import { KeysLocalStorage } from 'shared/enums/keys-local-storage.enum';

import { HeaderLocalhostKeys } from 'features/header/enums/header-localhost-keys.enum';
import { PartnerHeaderFeature } from 'features/header/ts-types';

//set
export const setAccessTokenToLocalStorage = (access_token: string) =>
  localStorage.setItem(KeysLocalStorage.access_token, access_token);

//get
export const getAccessTokenFromLocalStorage = () =>
  localStorage.getItem(KeysLocalStorage.access_token);

//remove
export const removeAccessTokenFromLocalStorage = () =>
  localStorage.removeItem(KeysLocalStorage.access_token);

//refresh token
export const setRefreshTokenToLocalStorage = (refresh_token: string) =>
  localStorage.setItem(KeysLocalStorage.refresh_token, refresh_token);

export const getRefreshTokenFromLocalStorage = () =>
  localStorage.getItem(KeysLocalStorage.refresh_token);

export const removeRefreshTokenFromLocalStorage = () =>
  localStorage.removeItem(KeysLocalStorage.refresh_token);

export const getPartnerHeaderFeaturesFromLocalStorage = (): string | null => {
  return localStorage.getItem(HeaderLocalhostKeys.PARTNER_HEADER_FEATURES);
};

export const setPartnerHeaderFeaturesToLocalStorage = (
  value: PartnerHeaderFeature[]
): void => {
  localStorage.setItem(
    HeaderLocalhostKeys.PARTNER_HEADER_FEATURES,
    JSON.stringify(value)
  );
};

export const removePartnerHeaderFeaturesFromLocalStorage = () =>
  localStorage.removeItem(HeaderLocalhostKeys.PARTNER_HEADER_FEATURES);
